<!-- <div class="card d-flex flex-column">
<div class="row">
  <div class="col-1"></div>
  <div class="col-10 header">
    <span class="header">Kiosk</span>
  </div>
  <div class="col-1">
    <button
      type="button"
      class="btn-close float-end"
      data-bs-dismiss="modal"
      aria-label="Close"
      style="margin-right:10px; margin-top:10px;"
      (click)="escapeKioskMode()"
    ></button>
  </div>
  <hr class="divider" />

</div>
</div> -->
@if (kiosk_selection==='fill_out_form_4473') {
  <app-buyer-4473></app-buyer-4473>
}
